export function createIdempotencyKey(prefix: string) {
  return `${prefix}_${crypto.randomUUID()}`;
}
